import type { TonyteActivity } from '../types';

// Curated Dresden events – 12 May 2026
// Image URLs point to Firebase Storage (uploaded by seed script).

const IMG = (filename: string) =>
  `https://tonyte.app/event-images/${filename}`;

export const DRESDEN_MAY_12_EVENTS: TonyteActivity[] = [
  {
    id: '2026-05-12-various-dresden-locations-54-internationales-dixielandfestival-dresden',
    title: '54. Internationales Dixielandfestival Dresden',
    description:
      "The legendary International Dixieland Festival transforms Dresden into a city-wide live music experience for its 54th edition. Expect jazz performances across outdoor stages, brass bands marching through the Altstadt, riverside terraces packed with music lovers, and the kind of spontaneous street-corner sessions that make Dixieland week unlike any other festival in Europe. From the Neumarkt to the Elbufer, the city exhales jazz for a full week. Whether you're a jazz devotee or simply swept up in the atmosphere, Dresden on Dixieland week is something genuinely unforgettable.",
    location: 'Dresden City Center, 01067 Dresden',
    address: 'Dresden City Center, 01067 Dresden',
    venueName: 'Various venues across Dresden',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Dixieland Festival Dresden',
    startDate: '2026-05-12',
    endDate: '2026-05-12',
    startTime: '11:00',
    endTime: '23:59',
    coordinates: { lat: 51.0504, lng: 13.7381 },
    coverImageUrl: IMG('Festival_stage_with_pyrotechnics_202605090203_4.jpeg'),
    coverPhoto: IMG('Festival_stage_with_pyrotechnics_202605090203_4.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    musicGenres: ['Jazz', 'Dixieland', 'Swing'],
    hashtags: ['Dixieland', 'JazzFestival', 'LiveMusic', 'Dresden', 'FestivalVibes', 'Swing'],
    tags: ['dixieland', 'jazz-festival', 'live-music', 'outdoor', 'social', 'festival'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: '2026-05-12-st-pauli-salon-buhne-frei-open-stage-night',
    title: 'Bühne frei! – Open Stage Night',
    description:
      "A relaxed and welcoming open-stage evening where anyone can take the mic and perform — music, poetry, comedy, spoken word, dance, or whatever else they feel like bringing. St. Pauli Salon's underground atmosphere is perfectly suited to this kind of unpredictable, human, unfiltered night. Sign-up sheets go around from 18:30. Expect the lineup to be completely different from whatever you were imagining. That's the point.",
    location: 'Hechtstraße 32, 01097 Dresden',
    address: 'Hechtstraße 32, 01097 Dresden',
    venueName: 'St. Pauli Salon',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'St. Pauli Salon',
    startDate: '2026-05-12',
    endDate: '2026-05-12',
    startTime: '19:00',
    endTime: '23:00',
    coordinates: { lat: 51.0705, lng: 13.7358 },
    coverImageUrl: IMG('Cafe_night_diverse_people_talking_202605090203_4.jpeg'),
    coverPhoto: IMG('Cafe_night_diverse_people_talking_202605090203_4.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    musicGenres: ['Mixed', 'Acoustic', 'Spoken Word'],
    hashtags: ['OpenMic', 'DresdenNightlife', 'CreativeNight', 'StudentEvents', 'LivePerformance', 'OpenStage'],
    tags: ['open-mic', 'open-stage', 'poetry', 'student', 'social', 'underground', 'creative'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: '2026-05-12-whisky-manufaktur-h42-billy-cobham-quintet-time-machine',
    title: 'Billy Cobham Quintet – "Time Machine"',
    description:
      'Legendary drummer Billy Cobham brings his iconic jazz fusion sound to Dresden with the "Time Machine" tour. One of the most important percussionists in the history of jazz and fusion, Cobham built the rhythmic foundation of Miles Davis\'s electric period and defined an entire era of jazz-rock. The Dresdner Whisky Manufaktur H42 is an inspired setting: intimate, refined, with the kind of focused listening atmosphere that rewards music of this calibre. Arrive early. This one sells.',
    location: 'Hamburger Straße 42, 01067 Dresden',
    address: 'Hamburger Straße 42, 01067 Dresden',
    venueName: 'Dresdner Whisky Manufaktur H42',
    city: 'Dresden',
    category: 'culture',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Dresdner Whisky Manufaktur H42',
    startDate: '2026-05-12',
    endDate: '2026-05-12',
    startTime: '19:30',
    endTime: '22:30',
    coordinates: { lat: 51.0476, lng: 13.7243 },
    coverImageUrl: IMG('Candlelight_concert_in_hall_202605090203.jpeg'),
    coverPhoto: IMG('Candlelight_concert_in_hall_202605090203.jpeg'),
    approved: true,
    isFree: false,
    maxParticipants: 0,
    musicGenres: ['Jazz Fusion', 'Instrumental', 'Funk'],
    hashtags: ['BillyCobham', 'JazzFusion', 'LiveConcert', 'DresdenMusic', 'ConcertNight', 'FusionJazz'],
    tags: ['concert', 'jazz', 'fusion', 'live-music', 'instrumental', 'funk'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
  {
    id: '2026-05-12-various-dresden-locations-dixieland-city-atmosphere-dresden-tonight',
    title: 'Dixieland City Atmosphere – Dresden Tonight',
    description:
      "Even outside the official Dixieland Festival stages, Dresden becomes a different city on festival evenings. Neustadt bars spill onto the pavement, the Elbufer terraces buzz with conversation and music, and the kind of spontaneous social energy that the city only generates a few times a year takes hold. Street musicians set up between official stages, impromptu sessions break out in courtyards, and the atmosphere of a city that has remembered how to enjoy itself fills every corner. No ticket required — just show up, follow the music, and see where the evening takes you.",
    location: 'Elbufer & Neustadt, 01099 Dresden',
    address: 'Elbufer & Neustadt, 01099 Dresden',
    venueName: 'Neustadt / Altstadt / Elbufer',
    city: 'Dresden',
    category: 'nightlife',
    entryType: 'official_event',
    sourceType: 'curated_event',
    hostId: 'system',
    hostName: 'Tonyte Curation',
    startDate: '2026-05-12',
    endDate: '2026-05-12',
    startTime: '18:00',
    endTime: '01:00',
    coordinates: { lat: 51.0530, lng: 13.7430 },
    coverImageUrl: IMG('Rooftop_party_dancing_with_cockt…_202605090203_2.jpeg'),
    coverPhoto: IMG('Rooftop_party_dancing_with_cockt…_202605090203_2.jpeg'),
    approved: true,
    isFree: true,
    maxParticipants: 0,
    musicGenres: ['Jazz', 'Street Music'],
    hashtags: ['CityVibes', 'DresdenTonight', 'Neustadt', 'BarHopping', 'LiveJazz', 'StreetMusic'],
    tags: ['social', 'city-vibes', 'outdoor', 'nightlife', 'meetup', 'bar-hopping', 'riverside'],
    visibility: 'public',
    createdAt: '2026-05-01T00:00:00.000Z',
    createdBy: 'system',
  },
];
